/**
 * @author caijianjia
 * @date 2020/4/8 10:35 上午
 */
let Vuex = null

export const utilsSetVuex = a => {
  Vuex = a
  return Vuex
}

/**
 * 将数组转乘 key value children 格式
 * @param arr
 */
export function FormatData (arr) {
  let obj = {}
  return arr.map(v => {
    obj = {
      key: `${v.id}`,
      value: v.name
    }
    if (v.childrens && v.childrens.length > 0) {
      obj.children = this.getNewChilrens(v.childrens)
    }
    return {
      ...obj,
      ...v
    }
  })
}
/**
 * 递归获取所有子节点的数据
 * @param data 数组
 * */
export function getNewChilrens (data) {
  let obj = {}
  return data.map(v => {
    obj = {
      key: `${v.id}`,
      value: v.name
    }
    if (v.childrens && v.childrens.length > 0) {
      obj.children = this.getNewChilrens(v.childrens)
    }
    return obj
  })
}

/***
 * 通过attr获取当前编辑的对象
 * @param attr 字段唯一标识
 * @param data 当前所有字段
 */
export function getObjByAttr ({ attr, data }) {
  let obj = {}
  data.map(v => {
    if (`${v.attr}` === `${attr}`) {
      obj = v
    }
  })
  return obj
}

/***
 * 通过attr获取当前编辑的对象的索引
 * @param attr 字段唯一标识
 * @param data 当前所有字段
 */
export function getIndexByAttr ({ attr, data }) {
  let index = -1
  data && data.map((v, i) => {
    if (`${v.attr}` === `${attr}`) {
      index = i
    }
  })
  return index
}

/***
 * 将自定义组件的值转换成表单标准格式
 * @param obj 当前所有字段
 */
export function getArrByDiy ({ obj }) {
  const newObj = obj
  const arr = []
  if (newObj) {
    let temp = JSON.parse(newObj).layout
    temp = temp.filter(v => v.config)
    temp.map(v => {
      arr.push(v.config[0])
    })
  }
  console.log('arr==>', arr)
  if (arr && arr.length > 0) {
    return arr
  }
  return newObj
}

/**
 * 获取所有有attr属性的字段值
 * @param data 数组
 * */
export function getObjByArr ({ data }) {
  const newData = data
  const obj = {}
  try {
    newData.map(v => {
      if (v.attr) {
        obj[v.attr] = v.value
      }
    })
  } catch (e) {
    console.log('utils->转换失败==>', e)
  }
  return obj
}

/**
 * 获取节点的所有父级节点
 * @param data2 整个树
 * @param nodeId2 某节点的id
 * */
export function getParentNode (data2, nodeId2) {
  var arrRes = []
  if (data2.length === 0) {
    if (nodeId2) {
      arrRes.unshift(data2)
    }
    return arrRes
  }
  const rev = (data, nodeId) => {
    for (var i = 0, length = data.length; i < length; i++) {
      const node = data[i]
      if (node.id === nodeId) {
        arrRes.unshift(node)
        rev(data2, node.parent_id)
        break
      } else {
        if (node.childrens) {
          rev(node.childrens, nodeId)
        }
      }
    }
    return arrRes
  }
  arrRes = rev(data2, nodeId2)
  return arrRes
}

/**
 * 获取视频第一帧画面
 * @param eleVideo 当前视频元素
 * @param eleTarget 第一帧渲染到当前元素内
 * @param imgWidth 图片渲染宽度
 * @param imgHeight 图片渲染高度
 * */
export function getVideoFirstImg ({ eleVideo, eleTarget, imgWidth = 400, imgHeight = 300 }) {
  const canvas = document.createElement('canvas')
  const img = document.createElement('img')
  eleVideo.setAttribute('crossOrigin', 'anonymous')
  canvas.width = eleVideo.clientWidth
  canvas.height = eleVideo.clientHeight
  eleVideo.onloadeddata = () => {
    canvas.getContext('2d').drawImage(eleVideo, 0, 0, canvas.width, canvas.height)
    const dataURL = canvas.toDataURL('image/png')
    img.src = dataURL
    img.width = imgWidth
    img.height = imgHeight
    eleTarget.appendChild(img)
  }
}

/**
 * 获取路径中的md5值
 * @param value 全路径
 * */
export function getMd5 (value) {
  let newValue = value
  try {
    newValue = newValue.match(/[0-9a-fA-F]{32}/g)
    if ( Array.isArray(newValue) ) {
      newValue = newValue[0]
    }
  } catch (e) {
    console.log('转换失败==>', e)
  }
  return newValue
}

/**
 * 获取html路径中的md5值
 * @param value 全路径
 * */
export function getHtmlMd5 (value) {
  let newValue = value
  try {
    const arr = newValue.split('.com/')
    let calcValue = arr[1]
    if (calcValue.indexOf('/index.html') > -1) {
      calcValue = calcValue.replace('/index.html', '')
    } else if (calcValue.indexOf('.html') > -1) { calcValue = calcValue.replace('.html', '') }
    newValue = calcValue
  } catch (e) {
    console.log('转换失败==>', e)
  }
  return newValue
}

/**
 * 获取html地址
 * @param value 全路径 【xxx/index.html】
 * */
export function getHtml (value) {
  let newValue = value
  try {
    if (newValue.indexOf('.com/')) {
      const arr = newValue.split('.com/')
      let calcValue = arr[1]
      if (calcValue.indexOf('/index.html') > -1) { calcValue = calcValue.replace(('/index.html', '.index.html')) }
      newValue = calcValue
    }
  } catch (e) {
    console.log('转换失败==>', e)
  }
  return newValue
}
/**
 * 字符串日期转成年月日
 * @param date 时间字符串
 * */
export function dateToString ({ date }) {
  const newDate = new Date(date)
  let result = ''
  const Y = newDate.getFullYear() + '-'
  const M = (newDate.getMonth() + 1 < 10 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1) + '-'
  const D = newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate()
  result = Y + M + D
  if (result.substr(0, 1) !== '2') {
    result = ''
  }
  return result
}

/**
 * 判断是否有权限
 * @param name 权限名称
 * */
export function isAuth (name) {
  let state = false
  try {
    state = Vuex.state.permissions[name]
  } catch (e) {
    console.log('判断权限失败==>', e)
  }
  // console.log('name==>', Vuex.state.permissions, name, state)
  return state
}

/**
 * 递归获取所有子节点的权限数据
 * @param data 数组
 * */
export function getAuthChilrens (data) {
  let obj = {}
  const newData = data.map(v => {
    return {
      ...v,
      isShow: isAuth(v.meta.auth) && !v.hide
    }
  })
  return newData.map(v => {
    obj = v
    let children = v.children
    // 如果子项存在隐藏，父级需要判断子项是否有数据
    if (Array.isArray(children)) children = children.filter(v => !v.hide)
    if (children && children.length > 0) {
      obj.children = getAuthChilrens(children)
    } else {
      delete obj.children
    }
    return obj
  })
}

/**
 * 规则分类加权限
 * @param data 整个树
 * @params params 参数
 * */
export function getRuleAuth (data, param) {
  let obj = {}
  const newData = data
  return newData.map(v => {
    obj = {
      ...v,
      ...param
    }
    if (v.childrens && v.childrens.length > 0) {
      obj.childrens = getRuleAuth(v.childrens, param)
    }
    return obj
  })
}

/**
 * 获取明天的GMT时间戳
 * */
export function getNextDay () {
  const day = new Date()
  return day.setTime(day.getTime() + 24 * 60 * 60 * 1000)
}

/**
 * 将已有的树型节点字段转换成自己想要的字段格式
 * 例如 {id, name, leaf} => {value, label, children}
 * @param oldKeys | ['leaf', 'id', 'name']
 * @param newKeys | ['children', 'value', 'label']
 * 注意: 数组第一个参数必须是孩子级字段
 */
export function oldTree2NewTree ({ data, oldKeys, newKeys }) {
  let obj = {}
  return data.map(v => {
    obj = v
    oldKeys.forEach((q, k) => {
      if (k !== 0) {
        obj[newKeys[k]] = obj[oldKeys[k]]
        delete obj[oldKeys[k]]
      }
    })
    if (v[oldKeys[0]] && v[oldKeys[0]].length > 0) {
      obj[newKeys[0]] = getTreeNewChilrens({ data: v[oldKeys[0]], oldKeys, newKeys })
      delete obj[oldKeys[0]]
    }
    return obj
  })
}
/**
 * 递归树形节点获取所有子节点的数据
 * @param data 数组
 * */
export function getTreeNewChilrens ({ data, oldKeys, newKeys }) {
  let obj = {}
  return data.map(v => {
    obj = v
    oldKeys.forEach((q, k) => {
      if (k !== 0) {
        obj[newKeys[k]] = obj[oldKeys[k]]
        delete obj[oldKeys[k]]
      }
    })
    if (v[oldKeys[0]] && v[oldKeys[0]].length > 0) {
      obj[newKeys[0]] = getTreeNewChilrens({ data: v[oldKeys[0]], oldKeys, newKeys })
      delete obj[oldKeys[0]]
    }
    return obj
  })
}



// WEBPACK FOOTER //
// ./src/utils/utils.js